"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// angular  modules
var core_1 = require("@angular/core");
var platform_browser_1 = require("@angular/platform-browser");
var forms_1 = require("@angular/forms");
var http_1 = require("@angular/http");
// vendor
var cookies_service_1 = require("angular2-cookie/services/cookies.service");
var Raven = require("raven-js");
var constants_1 = require("./constants");
Raven
    .config('https://abe4cc5112f34eaf8f930285e7ef229c@sentry.io/71410', {
    release: constants_1.VERSION
})
    .install();
var RavenErrorHandler = (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        Raven.captureException(err.originalError || err);
        console.error(err);
    };
    return RavenErrorHandler;
}());
exports.RavenErrorHandler = RavenErrorHandler;
// components
var components_1 = require("./components");
// services
var services_1 = require("./services");
// router
var router_1 = require("@angular/router");
var index_router_1 = require("./index.router");
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    core_1.NgModule({
        // modules
        imports: [
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            router_1.RouterModule.forRoot(index_router_1.appRoutes)
        ],
        // components
        declarations: [
            components_1.AppComponent,
            components_1.HeaderComponent,
            components_1.ModalComponent,
            components_1.PacksBoxComponent,
            components_1.ModalHelpComponent,
            components_1.MainComponent,
            components_1.LevelsBoxComponent,
            components_1.LevelComponent,
            components_1.ModalSuccessComponent,
            components_1.ModalDescriptionComponent,
            components_1.ModalHelpAddonComponent,
            components_1.UserMenuComponent,
            components_1.ModalHelpAddonProgressComponent,
        ],
        // services
        providers: [
            services_1.EventService,
            services_1.LocalizationService,
            services_1.ProgressService,
            services_1.PackLevelService,
            services_1.StorageService,
            cookies_service_1.CookieService,
            services_1.ToolService,
            services_1.UserService,
            services_1.LevelBoxGuardService,
            services_1.LevelGuardService,
            services_1.ShortPathGameGuardService,
            services_1.ResourcePreloaderService,
            services_1.LevelPermutationAnalyzerService,
            services_1.MigrationService,
            {
                provide: core_1.APP_INITIALIZER,
                useFactory: function (preloader, migration) {
                    migration.migrate();
                    return function () { return preloader.load(); };
                },
                deps: [services_1.ResourcePreloaderService, services_1.MigrationService],
                multi: true
            },
            {
                provide: core_1.ErrorHandler,
                useClass: RavenErrorHandler
            }
        ],
        bootstrap: [components_1.AppComponent]
    })
], AppModule);
exports.AppModule = AppModule;



//////////////////
// WEBPACK FOOTER
// ./src/index.module.ts
// module id = 232
// module chunks = 0